import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { initializeNavigationMiddleware } from './redux/state-areas/navigation/actions';

const NavigationInitializer = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(initializeNavigationMiddleware(navigate));    
  }, []);

  return null;
};

export default NavigationInitializer;
